import { toGoLang, getComponentList, safeInteropRegister, convertFinsembleLaunchGroupAppd2GlueGroupOptions } from "../../api-polyfill/src/common/windowFunctions";
import { debounce } from "lodash";
export class AppService {
    constructor(glue, logger, router) {
        this.glue = glue;
        this.logger = logger;
        this.router = router;
    }
    async loadUserDefinedApps() {
        const { data: preferences } = await toGoLang(() => this.glue.prefs.get("IO.Global.UserDefinedApps"));
        const definitions = Object.values(preferences?.data ?? {}).map((params) => {
            return {
                type: "window",
                name: params.name,
                title: params.name,
                details: {
                    url: params.url
                },
                customProperties: {
                    isUserDefined: true
                }
            };
        });
        if (definitions.length) {
            this.logger.debug("app-service - Adding user defined apps", preferences?.data);
        }
        const { err } = await toGoLang(() => this.glue.appManager.inMemory.import(definitions, "merge"));
        if (err) {
            this.logger.error("app-service - Error adding userDefinedApps", preferences?.data, err);
        }
    }
    async appUpdateListener() {
        const updateApps = debounce(async () => {
            this.logger.debug("app-service - updateApps from either onAppAdded or onAppRemoved");
            const { err, data } = await getComponentList(this.glue);
            if (!err && data) {
                this.logger.debug("app-service - Launcher.update", Object.keys(data));
                this.router.publish("Launcher.update", {
                    componentList: data
                });
            }
        }, 1500);
        this.glue.appManager.onAppAdded(() => {
            updateApps();
        });
        this.glue.appManager.onAppRemoved(() => {
            updateApps();
        });
    }
    async spawnLaunchGroup(params) {
        const { appd } = params;
        const { err, data: glueOptions } = await convertFinsembleLaunchGroupAppd2GlueGroupOptions(this.glue, appd);
        if (err || !glueOptions) {
            const error = "Invalid launch group configuration. Check logs.";
            return { error };
        }
        const { err: error, data } = await toGoLang(() => this.glue.windows.groups.create(glueOptions));
        return {
            error,
            data: data?.[0]?.id
        };
    }
    async addListeners() {
        await this.glue.interop.register("FSBL.Clients.AppsClient.spawnLaunchGroup", safeInteropRegister(async (params) => await this.spawnLaunchGroup(params), this.logger));
    }
    async start() {
        await this.addListeners();
        await this.appUpdateListener();
    }
}
